"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSavedStateSharingApi = exports.SdPlatformSavedStateSharingQueryEmbeddableFields = void 0;
const ResourcesApi_1 = require("./commons/ResourcesApi");
const SdPlatformRequestId_1 = require("../api/SdPlatformRequestId");
var SdPlatformSavedStateSharingQueryEmbeddableFields;
(function (SdPlatformSavedStateSharingQueryEmbeddableFields) {
    SdPlatformSavedStateSharingQueryEmbeddableFields["User"] = "user";
    SdPlatformSavedStateSharingQueryEmbeddableFields["SavedState"] = "saved_state";
    SdPlatformSavedStateSharingQueryEmbeddableFields["Provider"] = "provider";
})(SdPlatformSavedStateSharingQueryEmbeddableFields = exports.SdPlatformSavedStateSharingQueryEmbeddableFields || (exports.SdPlatformSavedStateSharingQueryEmbeddableFields = {}));
/**
 * Operations for saved state sharing relationships.
 */
class SdPlatformSavedStateSharingApi extends ResourcesApi_1.ResourcesApi {
    get __resourcePath() {
        return "saved_state_sharing";
    }
    /**
      * Create a saved state sharing relationship
      * @param body {@link SdPlatformResponseSavedStateSharingCreate}
      * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseSavedStateSharing} as response.
      */
    create(body) {
        return super.__post(SdPlatformRequestId_1.RequestId.SavedStateCreate, body);
    }
    /**
      * Create multiple sharings.
      * @param body {@link SdPlatformRequestSavedStateSharingCreateMultiple}
      * @returns the {@link SdPlatformPostResponse} with {@link SdPlatformResponseModelSharing} as data response.
      */
    createMultiple(body) {
        return super.__action(SdPlatformRequestId_1.RequestId.ModelSharingCreateMultiple, ResourcesApi_1.Action.Post, "saved_state_sharing_multiple", body);
    }
    /**
     * Delete a saved state.
     * @param saved_state_sharing_id Id of the saved state sharing relationship to delete.
     * @returns the {@link SdPlatformDeleteResponse} as response.
     */
    delete(saved_state_sharing_id) {
        return super.__delete(SdPlatformRequestId_1.RequestId.SavedStateSharingDelete, saved_state_sharing_id);
    }
    /**
      * Get saved state sharing relationships by saved state id and user id.
      * @param saved_state_id - saved state id.
      * @param user_id - user id.
      * @returns the {@link SdPlatformGetResponse} with array of {@link SdPlatformResponseSavedStateSharing} as data.
      */
    getBySavedStateAndUser(saved_state_id, user_id) {
        return super.__get(SdPlatformRequestId_1.RequestId.SavedStateSharingGetBySavedStateAndUser, `saved_state/${saved_state_id}/user/${user_id}`);
    }
    /**
     * Query saved state sharing relationships.
     * @param params {@link SdPlatformSavedStateSharingQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponseSavedStateSharing} as data.
     */
    query(query) {
        return super.__query(SdPlatformRequestId_1.RequestId.SavedStateSharingQuery, query);
    }
    /**
     * Query saved state sharing relationships by saved state id.
     * @param saved_state_id
     * @param query {@link SdPlatformSavedStateSharingQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponseSavedStateSharing} as data,
     */
    queryBySavedState(saved_state_id, query) {
        return super.__action(SdPlatformRequestId_1.RequestId.SavedStateSharingQueryBySavedState, ResourcesApi_1.Action.Post, `saved_state/${saved_state_id}/query`, query);
    }
    /**
     * Query saved state sharing relationships by user id.
     * @param user_id
     * @param query {@link SdPlatformSavedStateSharingQueryParameters}
     * @returns the {@link SdPlatformQueryResponse} with {@link SdPlatformResponseSavedStateSharing} as data,
     */
    queryByUser(user_id, query) {
        return super.__action(SdPlatformRequestId_1.RequestId.SavedStateSharingQueryByUser, ResourcesApi_1.Action.Post, `user/${user_id}/query`, query);
    }
    /**
     * Gets the model sharings grouped by user.
     * @param saved_state_id
     * @returns the {@link SdPlatformGetResponse} with {@link SdPlatformResponseSavedStateSharing} as data,
     */
    getGroupedByUser(saved_state_id) {
        return super.__action(SdPlatformRequestId_1.RequestId.SavedStateSharingGroupedByuser, ResourcesApi_1.Action.Get, `saved_state/${saved_state_id}/grouped_by_user`, {});
    }
}
exports.SdPlatformSavedStateSharingApi = SdPlatformSavedStateSharingApi;
//# sourceMappingURL=SdPlatformSavedStateSharingApi.js.map